import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  updateHolidayResponderFailure,
  updateHolidayResponderSuccess,
} from "../slices/features/holidayResponder";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* updateHolidaySaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.updateHolidayResponder,
      baseUrl,
      id,
      data
    );
    yield put(updateHolidayResponderSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(updateHolidayResponderFailure({ statusCode, statusText }));
  }
}

export function* watchUpdateHolidayResponder() {
  yield takeLatest(
    RequestTypes.UPDATE_HOLIDAY_AUTORESPONDER,
    updateHolidaySaga
  );
}
